global.$ = global.jQuery = $;
import { formatLeadDate } from './page-date.mjs';

import TomSelect from "tom-select";
import "tom-select/src/scss/tom-select.scss";

import '../styles/style.scss';
import '../styles/style-home.scss';
import '../styles/forms.scss';
import '../styles/lead.scss';

import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import { slotValueToMinutes } from './lead-slot-time.mjs';

global.intlTelInput = intlTelInput;

function ZFLead() {
}

ZFLead.utmPValObj = ZFLead.utmPValObj || {};

ZFLead.utmPNameArr = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

ZFLead.prototype.zfutm_getLeadVal = function (pName) {
    var qStr = '';
    try {
        qStr = window.top.location.search.substring(1);
    } catch (e) {
        qStr = '';
    }
    var pNameTemp = pName + '=';
    var pValue = '';
    if (typeof qStr !== "undefined" && qStr !== null && qStr.length > 0) {
        var begin = qStr.indexOf(pNameTemp);
        if (begin != -1) {
            begin = begin + pNameTemp.length;
            var end = qStr.indexOf('&', begin);
            if (end == -1) {
                end = qStr.length;
            }
            pValue = qStr.substring(begin, end);
        }
    }
    if (pValue == undefined || pValue == '') {
        pValue = this.zfutm_gC(pName);
    }
    if (typeof pValue !== "undefined" && pValue !== null) {
        pValue = pValue.replace(/\+/g, ' ');
    }
    return pValue;
};

ZFLead.prototype.zfutm_sC = function (paramName, path, domain, secure) {
    var value = ZFLead.utmPValObj[paramName];
    if (typeof value !== "undefined" && value !== null) {
        var cookieStr = paramName + "=" + escape(value);
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + 7);
        cookieStr += "; expires=" + exdate.toGMTString();
        cookieStr += "; path=/";
        if (domain) {
            cookieStr += "; domain=" + escape(domain);
        }
        if (secure) {
            cookieStr += "; secure";
        }
        window.jfCookies.set( cookieStr );
    }
};

ZFLead.prototype.zfutm_ini = function () {
    for (var i = 0; i < ZFLead.utmPNameArr.length; i++) {
        var zf_pN = ZFLead.utmPNameArr[i];
        var zf_pV = this.zfutm_getLeadVal(zf_pN);
        if (typeof zf_pV !== "undefined" && zf_pV !== null) {
            ZFLead.utmPValObj[zf_pN] = zf_pV;
        }
    }
    for (var pkey in ZFLead.utmPValObj) {
        this.zfutm_sC(pkey);
    }
};


ZFLead.prototype.zfutm_gC = function (cookieName) {
    var cookieArr = window.jfCookies.read().split('; ');
    for (var i = 0; i < cookieArr.length; i++) {
        var cookieVals = cookieArr[i].split('=');
        if (cookieVals[0] === cookieName && cookieVals[1]) {
            return unescape(cookieVals[1]);
        }
    }
};
ZFLead.prototype.zfutm_iframeSprt = function () {
    var zf_frame = document.getElementsByTagName("iframe");
    for (var i = 0; i < zf_frame.length; ++i) {
        if ((zf_frame[i].src).indexOf('formperma') > 0) {
            var zf_src = zf_frame[i].src;
            for (var prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
                var utmPm = ZFLead.utmPNameArr[prmIdx];
                var utmVal = this.zfutm_gC(ZFLead.utmPNameArr[prmIdx]);
                if (typeof utmVal !== "undefined") {
                    if (zf_src.indexOf('?') > 0) {
                        zf_src = zf_src + '&' + utmPm + '=' + utmVal;
                    } else {
                        zf_src = zf_src + '?' + utmPm + '=' + utmVal;
                    }
                }
            }
            if (zf_frame[i].src.length < zf_src.length) {
                zf_frame[i].src = zf_src;
            }
        }
    }
};
ZFLead.prototype.zfutm_DHtmlSprt = function () {
    var zf_formsArr = document.forms;
    for (var frmInd = 0; frmInd < zf_formsArr.length; frmInd++) {
        var zf_form_act = zf_formsArr[frmInd].action;
        if (zf_form_act && zf_form_act.indexOf('formperma') > 0) {
            for (var prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
                var utmPm = ZFLead.utmPNameArr[prmIdx];
                var utmVal = this.zfutm_gC(ZFLead.utmPNameArr[prmIdx]);
                if (typeof utmVal !== "undefined") {
                    var fieldObj = zf_formsArr[frmInd][utmPm];
                    if (fieldObj) {
                        fieldObj.value = utmVal;
                    }
                }
            }
        }
    }
};
ZFLead.prototype.zfutm_jsEmbedSprt = function (id) {
    document.getElementById('zforms_iframe_id').removeAttribute("onload");
    var jsEmbdFrm = document.getElementById("zforms_iframe_id");
    var embdSrc = jsEmbdFrm.src;
    for (var prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
        var utmPm = ZFLead.utmPNameArr[prmIdx];
        var utmVal = this.zfutm_gC(ZFLead.utmPNameArr[prmIdx]);
        if (typeof utmVal !== "undefined") {
            if (embdSrc.indexOf('?') > 0) {
                embdSrc = embdSrc + '&' + utmPm + '=' + utmVal;
            } else {
                embdSrc = embdSrc + '?' + utmPm + '=' + utmVal;
            }
        }
    }
    jsEmbdFrm.src = embdSrc;
};
var zfutm_zfLead = new ZFLead();
zfutm_zfLead.zfutm_ini();
window.onload = function () {
    zfutm_zfLead.zfutm_iframeSprt();
    zfutm_zfLead.zfutm_DHtmlSprt();
}


var iti = 0;
var say = 0;
$(document).ready(function () {
    var toplamslide = $(".slidein li").length;
    var toplamslide = toplamslide - 1;
    var toplamslide1 = Math.abs(toplamslide) * -1;
    $(".slidein li").hide();
    $(".slidein li:first").fadeIn();
    $(".next").click(function () {
        if (say >= toplamslide) {
            say = 0;
        } else {
            say++;
        }
        $(".slidein li").hide();
        $(".slidein li").eq(say).fadeIn();
    });
    $(".prev").click(function () {
        if (say < toplamslide1) {
            say = 0;
        }
        say--;
        $(".slidein li").hide();
        $(".slidein li").eq(say).fadeIn();
    });
});


// jQuery v 2.2.4 requierd
// CDN link here - https://code.jquery.com/
// Add a box to the page and nest the elements inside (can include boxes with grouped content)
// The first element that is nested in the containing box will be what shows on page load
$(function () {
    new TomSelect("#selectTimepickerOption", {
        create: false,
        maxItems: 1,
        searchField: []
    });

    // Add a box to the page and nest the elements inside (can include boxes with grouped content)
    // The first element that is nested in the containing box will be what shows on page load
    // Add ID of box containing elements.
    var container = $("#lp-pom-box-1035");

    // Add ID of right button
    var right = $("#lp-pom-button-990");

    // Add ID of right button
    var left = $("#lp-pom-button-991");

    var time = 500;

    // code to select and centre elements
    container.children().css({
        'top': '50%',
        'left': '50%',
        'transform': 'translate(-50%, -50%)'
    });
    var allEls = container.children().not(":eq(0)");
    var notFirst = allEls.not(":eq(0)");
    notFirst.css('display', 'none');

    // Functions to cycle through the elements in the containing box and show/hide them
    function cycleRight(el, delay) {
        $(el[0]).fadeIn(500)
            .delay(delay)
            .fadeOut(500)
            .promise()
            .done(function () {
                $(el[1]).fadeIn(500);
                var putBack = el.splice(0, 1);
                allEls.push(putBack[0]);
            });
    }

    function cycleLeft(el, delay) {
        $(el[0]).fadeIn(500)
            .delay(delay)
            .fadeOut(500)
            .promise()
            .done(function () {
                $(el.last()).fadeIn(500);
                var putBack = el.splice(-1, 1);
                allEls.splice(0, 0, putBack[0]);
            });
    }

    function cycleTimeRight() {
        cycleRight(allEls, time);
        $(right).off('click');
        setTimeout(function () {
            $(right).on('click', cycleTimeRight);
        }, time * 3);
    }

    function cycleTimeLeft() {
        cycleLeft(allEls, time);
        $(left).off('click');
        setTimeout(function () {
            $(left).on('click', cycleTimeLeft);
        }, time * 3);
    }

    $(right).click(function () {
        cycleTimeRight();
    });

    $(left).click(function () {
        cycleTimeLeft();
    });
});

// Function to reveal lightbox and adding YouTube autoplay
function revealVideo(div, video_id) {
    var video = document.getElementById(video_id).src;
    document.getElementById(video_id).src = video + '&autoplay=1'; // adding autoplay to the URL
    document.getElementById(div).style.display = 'block';
}

// Hiding the lightbox and removing YouTube autoplay
function hideVideo(div, video_id) {
    var video = document.getElementById(video_id).src;
    var cleaned = video.replace('&autoplay=1', ''); // removing autoplay form url
    document.getElementById(video_id).src = cleaned;
    document.getElementById(div).style.display = 'none';
}

global.revealVideo = revealVideo;
global.hideVideo = hideVideo;

var $zoho = $zoho || {};
$zoho.salesiq = $zoho.salesiq || {
    widgetcode: "siq083250bba5b321fa5b33aeb4a1d1e4880daa37f5c1213e302242ee45171f06ab",
    values: {},
    ready: function () {
    }
};
var d = document;
var s = d.createElement("script");
s.type = "text/javascript";
s.id = "zsiqscript";
s.defer = true;
s.src = "https://salesiq.zohopublic.eu/widget";
var t = d.getElementsByTagName("script")[0];
t.parentNode.insertBefore(s, t);


window.addEventListener('DOMContentLoaded', function () {
        let timeZone = 'UTC';

        if ('gb' === COUNTRY_CODE) {
            timeZone = 'Europe/London';
        } else if ('fr' === COUNTRY_CODE) {
            timeZone = 'Europe/Paris';
        } else if ('be' === COUNTRY_CODE) {
            timeZone = 'Europe/Brussels';
        }

        // Source values set by jf_get_lead_page_info() in functions.php.
        // Keys must match the lead_page_source values exactly: 'Google-ads', 'Marketing-landing', 'Organic', 'Communication-landing'.
        const formSource = document.getElementById('form-source')?.value || 'Organic';
        const pageSourceConfig = {
            'Google-ads':        { suffix: '-Google-ads',        isMarketing: false, isOrganic: false },
            'Marketing-landing': { suffix: '-Marketing-landing', isMarketing: true,  isOrganic: false },
            'Organic':           { suffix: '',                   isMarketing: false, isOrganic: true  },
            'Communication-landing':    { suffix: '-Communication-landing', isMarketing: true,  isOrganic: false,  popupSource: 'lawyer-lead-page-Communication-landing' },
        };
        const config = pageSourceConfig[formSource] || pageSourceConfig['Organic'];

        function pushMarketingSource() {
            dataLayer.push({event: 'source_tracking', source: config.suffix.slice(1) || 'Marketing-landing'});
        }


        if ('gb' !== COUNTRY_CODE) {
            window.jfCookies.read().split(';').find(function (item) {
                if (
                    item.trim().startsWith('lawyer-lead-submitted')
                    || item.trim().startsWith('lawyer-lead-white-papers-submitted')
                ) {
                    Boxzilla.on('box.show', function (box) {
                        if (box.config.post.slug === 'lawyer-lead-page-freemium') {
                            box.overlay.remove()
                            box.element.remove()
                        }
                    });
                }
            });

            Boxzilla.on('box.show', function (box) {
                if (box.config.post.slug === 'lawyer-lead-page-freemium') {
                    if (config.isMarketing) {
                        const lawyerLeadSource = document.getElementById('lawyer-lead-source');
                        if (lawyerLeadSource) {
                            lawyerLeadSource.value = config.popupSource || 'Marketing-landing';
                        }
                        pushMarketingSource();
                    }

                    dataLayer.push({
                        event: "dataLayer.gaEvent",
                        gaEvent: {
                            category: "Freemium",
                            action: config.isOrganic ? "lawyerlead_popup_exit_promo" : "lawyer-lead-page" + config.suffix,
                        },
                    });
                }
            });
        }

        // Wall-clock "now" in the site's timezone. Re-read wherever slots are
        // compared: a tab left open (or restored from bfcache) must not keep
        // offering slots that are already past (DDT-4355).
        function nowInSiteTz() {
            return new Date(new Date().toLocaleString(
                'en-US',
                {timeZone: timeZone}
            ));
        }

        let currentDateAndHour = nowInSiteTz();
        const slotBufferMinutes = 10;


        let isTodayAvailableBasedOnWorkingHourAndHourNow = true;
        checkWorkingHours();
        fieldEvents();
        populateSelectDatepickerOption();

        setTimeout(() => {
            hideTimeSlotsForCurrentDates();
            changeTimeDropdownPlaceholder();
        }, 50);


        document.querySelector('#selectDatepickerOption').addEventListener('change', () => {
            onDateChangeReloadHourOptions();
            hideTimeSlotsForCurrentDates();
            changeTimeDropdownPlaceholder();
        })

        const intervalForTimeSlotSetup = setInterval(function () {
                if (document.querySelector('#time-slot-section .ts-control')) {
                    document.querySelector('#time-slot-section .ts-control').addEventListener('click', () => {
                        hidePastTimeSlots();
                        hideTimeSlotsForCurrentDates();
                    });

                    clearInterval(intervalForTimeSlotSetup);
                }
            },
            500);

        // Back/forward cache restores the page with its old JS state: the
        // date list and the default slot were computed at the original load.
        const loadedDateKey = holidayDateKey(currentDateAndHour);

        window.addEventListener('pageshow', (e) => {
            if (!e.persisted) {
                return;
            }

            // A new day invalidates the whole date list; rebuild from scratch.
            if (holidayDateKey(nowInSiteTz()) !== loadedDateKey) {
                window.location.reload();
                return;
            }

            hidePastTimeSlots();
            changeTimeDropdownPlaceholder();
        });

        const form = document.getElementById('lawyer-lead-form');
        const successContainer = document.getElementById('lawyer-lead-form-success');
        const errorContainer = document.getElementById('lawyer-lead-error');

        document.getElementById('submit-form-button').addEventListener('click', function (e) {
            e.preventDefault();
            const firstNameValid = validateField('lead-first-name');
            const lastNameValid = validateField('lead-last-name');
            const phoneValid = validateField('lead-phone');
            const emailValid = validateField('lead-email');

            const contactType = document.querySelector('input[name="contactType"]:checked')?.value;

            let questionValid = true;

            if (contactType === 'askQuestion') {
                questionValid = validateQuestionTextArea();
            }

            if (firstNameValid && lastNameValid && phoneValid && emailValid && questionValid) {
                submitForm();
            }
        });

        $('.dropdown-item').on('click', function () {
            document.querySelectorAll('.dropdown-item').forEach(element => {
                element.classList.remove('active');
            });

            document.querySelector('#lead-motivation').setAttribute("value", this.value);
            document.querySelector('#lead-motivation').innerHTML = this.value;

            this.classList.add('active');

            validateField('lead-motivation');
        });

        function submitForm() {
            const radio = document.getElementById('dateSlotPicker').checked ? true : false;

            let selectedTime, selectedEndTime, startDate;

            if (document.querySelector('input[type=radio][name=contactType]:checked').value === 'fixedTime') {
                const now = new Date();

                selectedTime = now.getHours().toString().padStart(2, '0') +
                    ':' + now.getMinutes().toString().padStart(2, '0') +
                    ':' + now.getSeconds().toString().padStart(2, '0') + getStandardTimeZone();

                const futureTime = new Date(now.getTime() + 30 * 60000);
                selectedEndTime = futureTime.getHours().toString().padStart(2, '0') +
                    ':' + futureTime.getMinutes().toString().padStart(2, '0') +
                    ':' + futureTime.getSeconds().toString().padStart(2, '0') + getStandardTimeZone();

                startDate = now.toISOString().split('T')[0];
            } else {
                if (radio && isSelectedSlotPast()) {
                    // The slot went stale while the page sat open: re-pick the
                    // first bookable one and let the user confirm it.
                    hidePastTimeSlots();
                    changeTimeDropdownPlaceholder();
                    // Still past = no bookable slot was left to re-pick.
                    flagTimeSlotForReconfirm(!isSelectedSlotPast());
                    return;
                }

                startDate = document.getElementById('selectDatepickerOption').selectedOptions[0].dataset.date;
                selectedTime = document.getElementById('selectTimepickerOption').selectedOptions[0].dataset.time;
                selectedEndTime = document.getElementById('selectTimepickerOption').selectedOptions[0].dataset.endTime;
            }

            const singleLine4 = startDate + 'T' + selectedTime;
            const singleLine5 = startDate + 'T' + selectedEndTime;

            const data = {
                // We are currently removing 'lead-motivation' - SingleLine (in zoho form) from zoho data in task DDT-2831
                'action': 'submit_lawyer_lead',
                'Name_First': document.getElementById('lead-first-name').value,
                'Name_Last': document.getElementById('lead-last-name').value,
                'PhoneNumber_countrycode': document.getElementById('lead-phone').value,
                'Email': document.getElementById('lead-email').value,
                'Radio': radio,
                'SingleLine1': radio === true ? document.getElementById('selectDatepickerOption').value : '',
                'Dropdown1': radio === true ? document.getElementById('selectTimepickerOption').value : '',
                'SingleLine2': document.getElementById('gclid').value,
                'SingleLine3': document.getElementById('form-source').value,
                'SingleLine4': radio === true ? singleLine4 : '',
                'SingleLine5': radio === true ? singleLine5 : '',
                'landing_page': window.sessionStorage.getItem('landing-page') || '',
            };

            const url = window.jfUrls.ajax

            jQuery.post(
                url,
                data,
                function (response) {
                    if (response) {
                        form.classList.add('d-none');

                        successContainer.classList.remove('d-none');

                        dataLayer.push({'event': 'conversion_event_submit_lead_form'})

                        dataLayer.push({
                            event: "dataLayer.gaEvent",
                            gaEvent: {
                                category: "Lawyer Lead Page",
                                action: "Lead form lp_a complete",
                                label: "submit"
                            },
                        });

                        if (config.isMarketing) {
                            pushMarketingSource();
                        }

                        window.jfCookies.set( "lawyer-lead-submitted=true;" );

                        Boxzilla.on('box.show', function (box) {
                            if (box.config.post.slug === 'lawyer-lead-page-freemium') {
                                box.overlay.remove()
                                box.element.remove()
                            }
                        });
                    } else {
                        errorContainer.classList.remove('d-none');
                    }
                }
            );
        }

        function isSelectedSlotPast() {
            const dateOption = document.getElementById('selectDatepickerOption').selectedOptions[0];
            const timeOption = document.getElementById('selectTimepickerOption').selectedOptions[0];

            if (!dateOption || !timeOption) {
                return false;
            }

            const now = nowInSiteTz();
            const todayKey = holidayDateKey(now);
            const selectedDateKey = dateOption.dataset.date;

            if (selectedDateKey !== todayKey) {
                // YYYY-MM-DD compares lexically: an earlier day is past.
                return selectedDateKey < todayKey;
            }

            const nowInMinutes = now.getHours() * 60 + now.getMinutes();

            return slotValueToMinutes(timeOption.value, COUNTRY_CODE) <= nowInMinutes + slotBufferMinutes;
        }

        function flagTimeSlotForReconfirm(slotRepicked) {
            const control = document.querySelector('#time-slot-section .ts-control')
                || document.getElementById('selectTimepickerOption');
            const repickedMessage = document.getElementById('lead-slot-repicked-validation');
            const unavailableMessage = document.getElementById('lead-slot-unavailable-validation');

            control.style.setProperty('border', '1px solid red', 'important');

            if (repickedMessage && unavailableMessage) {
                if (slotRepicked) {
                    hide(unavailableMessage);
                    show(repickedMessage);
                } else {
                    hide(repickedMessage);
                    show(unavailableMessage);
                }
            }

            control.scrollIntoView({behavior: 'smooth', block: 'center'});

            const clearFlag = () => {
                control.style.removeProperty('border');

                if (repickedMessage && unavailableMessage) {
                    hide(repickedMessage);
                    hide(unavailableMessage);
                }
            };

            document.getElementById('selectTimepickerOption').addEventListener('change', clearFlag, {once: true});
            document.getElementById('selectDatepickerOption').addEventListener('change', clearFlag, {once: true});
        }

        function validateField(field) {
            if (field === 'lead-first-name') {
                const firstNameRegex = /([a-zA-Z',.-]+){2,30}/;
                const firstNameInput = document.getElementById(field);
                const firstNameValue = document.getElementById(field).value;
                const firstNameValidation = document.getElementById(field + '-validation');
                const isValidField = firstNameRegex.test(firstNameValue);

                if (isValidField) {
                    hide(firstNameValidation);
                    firstNameInput.setAttribute('style', "border: 1px solid #001D50 !important;");
                } else {
                    show(firstNameValidation);
                    firstNameInput.setAttribute('style', "border: 1px solid red !important;");
                }

                return isValidField;
            }

            if (field === 'lead-last-name') {
                const lastNameRegex = /([a-zA-Z',.-]+){2,30}/;
                const lastNameInput = document.getElementById(field);
                const lastNameValue = document.getElementById(field).value;
                const lastNameValidation = document.getElementById(field + '-validation');
                const isValidField = lastNameRegex.test(lastNameValue);

                if (isValidField) {
                    hide(lastNameValidation);
                    lastNameInput.setAttribute('style', "border: 1px solid #001D50 !important;");
                } else {
                    show(lastNameValidation);
                    lastNameInput.setAttribute('style', "border: 1px solid red !important;");
                }

                return isValidField;
            }

            if (field === 'lead-phone') {
                const phoneInput = document.getElementById(field);
                const phoneValidation = document.getElementById(field + '-validation');
                const phoneMatches = phoneInput.value.replace(/\s/g, '').match(/\d{9}/);

                const isValidField = null !== phoneMatches && phoneInput.value.length > 0;

                if (isValidField) {
                    hide(phoneValidation);
                    phoneInput.setAttribute('style', "border: 1px solid #001D50 !important;");
                } else {
                    show(phoneValidation);
                    phoneInput.setAttribute('style', "border: 1px solid red !important;");
                }

                return isValidField;
            }

            if (field === 'lead-email') {
                const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
                const emailInput = document.getElementById(field);
                const emailValue = document.getElementById(field).value;
                const emailValidation = document.getElementById(field + '-validation');
                const isValidField = emailRegex.test(emailValue);

                if (isValidField) {
                    hide(emailValidation);
                    emailInput.setAttribute('style', "border: 1px solid #001D50 !important;");
                } else {
                    show(emailValidation);
                    emailInput.setAttribute('style', "border: 1px solid red !important;");
                }

                return isValidField;
            }
        }

        function show(element) {
            if (element.classList.contains("hideMe")) {
                element.classList.remove("hideMe");
            }

            if (element.classList.contains("hideMeVal")) {
                element.classList.remove("hideMeVal");
            }
        }

        function hide(element) {
            if (!element.classList.contains("hideMe")) {
                element.classList.add("hideMe");
            }

            if (!element.classList.contains("hideMeVal")) {
                element.classList.add("hideMeVal");
            }
        }

        function fieldEvents() {
            const fieldNames = ['lead-first-name', 'lead-last-name', 'lead-phone', 'lead-email'];

            for (let i = 0; i < fieldNames.length; i++) {
                const field = fieldNames[i];

                if (!document.getElementById(field)) {
                    return;
                }

                document.getElementById(field).addEventListener('change', function () {
                    validateField(field);
                });

                document.getElementById(field).addEventListener('focusout', function () {
                    validateField(field);
                });
            }
        }

        function holidayDateKey(date) {
            const pad = (number) => String(number).padStart(2, '0');

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        }

        /**
         * Holiday state for a given YYYY-MM-DD date:
         *   'off'             -> whole day blocked (removed from the date picker)
         *   { openSlots: [] } -> only these slot values are bookable that day
         *   null              -> no holiday rule, normal availability
         */
        function holidayDayState(dateKey) {
            const settings = window.holidaySettings || {};
            const exceptions = settings.exceptions || {};
            const periods = settings.periods || [];
            const publicHolidays = window.publicHolidays || [];

            if (Object.prototype.hasOwnProperty.call(exceptions, dateKey)) {
                const openSlots = exceptions[dateKey] || [];

                // A listed day with no open slots is effectively fully off.
                return openSlots.length > 0 ? { openSlots } : 'off';
            }

            const isInPeriod = periods.some(
                (period) => period.start && period.end && dateKey >= period.start && dateKey <= period.end
            );

            // Off if inside a custom period or a public bank holiday (Yasumi).
            return (isInPeriod || publicHolidays.includes(dateKey)) ? 'off' : null;
        }

        function populateSelectDatepickerOption() {
            /*
             Here we get today's date and the next 5 days in format 'Monday 1 January' as required,
            and populate the select field with the options for the datepicker in French.
            */

            const selectField = document.getElementById('selectDatepickerOption');

            currentDateAndHour = nowInSiteTz();

            let daysToAdd = 0; // Counter to track days added to the select field
            let dayCounter = 0; // Counter to track days added to the select field

            while (dayCounter < 6) {
                let date = new Date();
                date.setDate(currentDateAndHour.getDate() + daysToAdd);

                // Removed only when fully off; exception days stay selectable
                // and are filtered at the slot level.
                const isBlocked = holidayDayState(holidayDateKey(date)) === 'off';



                let currentDateHours = currentDateAndHour.getHours();
                let currentDateMinutes = currentDateAndHour.getMinutes();
                const bufferTime = 10;

                const currentTotalMinutes = currentDateHours * 60 + currentDateMinutes;
                const workEndMinutes = 17 * 60 + 30; // 17:30 in minutes

                const isHourAfterWorkingHoursForToday = (currentTotalMinutes > (workEndMinutes - bufferTime))
                    && (0 === daysToAdd);

                if (isHourAfterWorkingHoursForToday) {
                    isTodayAvailableBasedOnWorkingHourAndHourNow = false;
                    daysToAdd = 1;
                    continue;
                }

                if (
                    date.getDay() !== 0
                    && date.getDay() !== 6
                    && false === isHourAfterWorkingHoursForToday
                    && !isBlocked
                ) {
                    // Skip Saturday (index 6) and Sunday (index 0), skip today if hour is after working hours

                    const formattedDate = formatLeadDate(date, document.documentElement.lang);

                    const option = document.createElement('option');
                    option.text = formattedDate;
                    // add date value in format 'YYYY-MM-DD' for attribute 'data-date'
                    // (local calendar date: toISOString() is UTC and gives the previous day before 02:00 Paris)
                    option.dataset.date = holidayDateKey(date);
                    selectField.add(option);
                    dayCounter++; // Increment day counter
                }

                daysToAdd++; // Increment days to add to the select field
            }

            new TomSelect("#selectDatepickerOption", {
                create: false,
                maxItems: 1,
                searchField: []
            });
        }

        if (document.getElementById('lawyer-lead-white-papers-submit-button')) {
            document.getElementById('lawyer-lead-white-papers-submit-button').addEventListener('click', submitLawyerLeadWhitePapersForm)
        }

        function submitLawyerLeadWhitePapersForm() {

            if (document.getElementById('lawyer-lead-email')) {
                if (document.getElementById('lawyer-lead-email').value.length > 0) {
                    hide(document.getElementById('lawyer-lead-email-val'))
                } else {
                    show(document.getElementById('lawyer-lead-email-val'))
                    return;
                }
            }


            function getFreemiumSource() {
                if (formSource === 'Communication-landing') {
                    return 'lawyer-lead-page-Communication-landing';
                }
                if (config.isMarketing) {
                    return formSource || '';
                }
                return document.getElementById('lawyer-lead-source')?.value || '';
            }

            const data = {
                'action': 'submit_lawyer_lead_white_papers',
                'email': document.getElementById('lawyer-lead-email').value,
                'source': getFreemiumSource(),
                // 'first_name': document.getElementById('lawyer-lead-first-name').value,
                // 'last_name': document.getElementById('lawyer-lead-last-name').value,
                // 'lawyer_function': document.getElementById('lawyer-lead-function').value,
                // 'lawyer_office': document.getElementById('lawyer-lead-office').value,
                // 'lawyer_school': document.getElementById('lawyer-lead-school').value,
            }

            const url = window.jfUrls.ajax
            jQuery.post(
                url,
                data
                , function (response) {
                    window.jfCookies.set( "lawyer-lead-white-papers-submitted=true;" );

                    if (response) {
                        dataLayer.push({
                            event: "dataLayer.gaEvent",
                            gaEvent: {
                                category: "Lawyer lead pop up",
                                action: "lawyerlead_complete_leadpage_livreblancexit",
                                label: "submit"
                            },
                        });

                        if (config.isMarketing) {
                            pushMarketingSource();
                        }

                        document.querySelector('.lawyer-lead-form-container').classList.add('d-none');
                        document.querySelector('.lawyer-lead-from-success-container').classList.remove('d-none');
                    }
                });
        }

        function checkWorkingHours() {
            const validWorkingTimeContainer = document.getElementById('time-picker-radio-buttons');
            const invalidWorkingTimeContainer = document.getElementById('invalid-working-time-option');
            const dateOptions = document.getElementById('datepickerOptions');

            if (!validWorkingTimeContainer || !invalidWorkingTimeContainer) {
                return;
            }

            const localHour = currentDateAndHour.getHours();
            const localMinute = currentDateAndHour.getMinutes();
            const localDay = currentDateAndHour.getDay();

            const startHourInLocalTime = 9;
            const endHourInLocalTime = 17;
            const isInWeekendDays = (localDay === 0 || localDay === 6);
            const isInWorkingHours =
                (localHour > startHourInLocalTime || (localHour === startHourInLocalTime && localMinute >= 15)) &&
                (localHour < endHourInLocalTime || (localHour === endHourInLocalTime && localMinute <= 30));

            const lunchBreakStart = 12;
            const lunchBreakEnd = 14;

            const isLunchBreak =
                (localHour > lunchBreakStart || (localHour === lunchBreakStart && localMinute >= 30)) &&
                localHour < lunchBreakEnd;

            if (isInWeekendDays || !isInWorkingHours || isLunchBreak) {
                validWorkingTimeContainer.classList.add('d-none');
                invalidWorkingTimeContainer.classList.remove('d-none');
                dateOptions.classList.remove('d-none');
                document.querySelector('#dateSlotPicker').checked = true;
            }
        }

        function getLocalTime(timeZone) {
            const localTime = new Date().toLocaleString('en-US', {timeZone: timeZone});

            return new Date(localTime);
        }

        function getStandardTimeZone() {
            const timezoneNumber = Math.abs(new Date().getTimezoneOffset() / 60);
            let timezone = null;

            if (timezoneNumber < 10) {
                timezone = "+0" + timezoneNumber + '00';
            } else {
                timezone = "+" + timezoneNumber + '00';
            }

            return timezone; // e.g., "+0200"
        }

        function hidePastTimeSlots() {
            let selectedDateObj = convertSelectedDateIntoObjectDate();

            if (selectedDateObj !== new Date().getDate()) {
                return
            }

            setTimeout(function () {
                const timeslots = document.querySelectorAll('#time-slot-section #selectTimepickerOption-ts-dropdown .option')

                currentDateAndHour = nowInSiteTz();
                const currentTimeInMinutes = currentDateAndHour.getHours() * 60 + currentDateAndHour.getMinutes();

                timeslots.forEach(slot => {
                    const optionTimeInMinutes = slotValueToMinutes(slot.dataset.value, COUNTRY_CODE);

                    if (optionTimeInMinutes <= currentTimeInMinutes + slotBufferMinutes) {
                        slot.classList.add('d-none');
                    }
                });
            }, 1);

        }

        function changeTimeDropdownPlaceholder() {
            if (false === isTodayAvailableBasedOnWorkingHourAndHourNow) {
                return
            }

            let selectedDateObj = convertSelectedDateIntoObjectDate();
            let firstAvailableSlot = null;
            const selectedDate = document.getElementById('selectDatepickerOption').selectedOptions[0].dataset.date;

            if (selectedDateObj !== new Date().getDate()) {
                const timeslots = Array.from(document.querySelectorAll('#selectTimepickerOption option'));

                timeslots.sort((a, b) => {
                    if (a.getAttribute('data-time') !== null && b.getAttribute('data-time') !== null) {
                        const timeA = a.getAttribute('data-time');
                        const timeB = b.getAttribute('data-time');
                        return timeA.localeCompare(timeB);
                    }
                    return 0;
                });

                const dayState = holidayDayState(selectedDate);

                timeslots.forEach(slot => {
                    if (firstAvailableSlot !== null) {
                        return;
                    }

                    if (dayState && dayState !== 'off') {
                        // Partially open day: default to the earliest open slot
                        // (slots are sorted ascending above).
                        if (dayState.openSlots.includes(slot.value)) {
                            firstAvailableSlot = slot;
                        }
                    } else if (slot.value === '09h30' || slot.value === '09:30AM') {
                        firstAvailableSlot = slot;
                    }
                });

            } else {
                const timeslots = Array.from(document.querySelectorAll('#selectTimepickerOption option'));

                currentDateAndHour = nowInSiteTz();
                const currentTimeInMinutes = currentDateAndHour.getHours() * 60 + currentDateAndHour.getMinutes();

                // We use this sort beacuse TomSelect changes the order of the options and 9:30 goes to last position
                timeslots.sort((a, b) => {
                    if (a.getAttribute('data-time') !== null && b.getAttribute('data-time') !== null) {
                        const timeA = a.getAttribute('data-time');
                        const timeB = b.getAttribute('data-time');
                        return timeA.localeCompare(timeB);
                    }
                    return 0;
                });

                timeslots.forEach(slot => {
                    const optionTimeInMinutes = slotValueToMinutes(slot.value, COUNTRY_CODE);

                    if (
                        optionTimeInMinutes > currentTimeInMinutes + slotBufferMinutes
                        && null === firstAvailableSlot
                    ) {
                        firstAvailableSlot = slot;
                    }
                });
            }

            const placeholder = document.querySelector('#time-slot-section .ts-control .item');
            if (placeholder && firstAvailableSlot) {
                placeholder.textContent = firstAvailableSlot.value;
                placeholder.setAttribute('data-value', firstAvailableSlot.value);
            }

            if (firstAvailableSlot) {
                document.querySelector('#selectTimepickerOption').value = firstAvailableSlot.value;
            }
        }

        function onDateChangeReloadHourOptions() {
            if (false === isTodayAvailableBasedOnWorkingHourAndHourNow) {
                return
            }

            let selectedDateObj = convertSelectedDateIntoObjectDate();

            if (selectedDateObj !== new Date().getDate()) {
                document.querySelectorAll('#time-slot-section #selectTimepickerOption-ts-dropdown .option').forEach(slot => {
                    slot.classList.remove('d-none');
                });
            }
        }

        function convertSelectedDateIntoObjectDate() {
            const availableDates = Array.from(document.querySelectorAll("#selectDatepickerOption option"));
            let selectedDate = document.getElementById('selectDatepickerOption').value;

            availableDates.forEach((date) => {
                if (date.value === selectedDate) {
                    selectedDate = date.getAttribute('data-date');
                }
            })
            return new Date(selectedDate).getDate();
        }

        // document.getElementById('askQuestionInput').addEventListener('blur', function () {
        //     validateQuestionTextArea();
        // });
        // document.getElementById('askQuestionInput').addEventListener('focusout', function () {
        //     validateQuestionTextArea();
        // });
        // document.getElementById('askQuestionInput').addEventListener('input', function () {
        //     validateQuestionTextArea();
        // });

        function validateQuestionTextArea() {
            const textArea = document.getElementById('askQuestionInput');
            const errorMinChars = document.getElementById('errorMessageMinChars');
            const errorMaxChars = document.getElementById('errorMessageMaxChars');
            const length = textArea.value.trim().length; // Trim to ignore leading/trailing spaces

            if (length < 1) {
                errorMaxChars.classList.add('d-none');
                errorMinChars.classList.remove('d-none');
                textArea.style.border = '1px solid red';
                return false;

            } else if (length > 500) {
                errorMinChars.classList.add('d-none');
                errorMaxChars.classList.remove('d-none');
                textArea.style.border = '1px solid red';
                return false;

            }

            errorMinChars.classList.add('d-none');
            errorMaxChars.classList.add('d-none');
            textArea.style.border = '';
            return true;

        }

        function hideTimeSlotsForCurrentDates() {
            const selectedDate = document.getElementById('selectDatepickerOption').selectedOptions[0].dataset.date;

            setTimeout(function () {
                const dayState = holidayDayState(selectedDate);

                // Only partial days filter here (full-off already off the picker).
                if (!dayState || dayState === 'off') {
                    return;
                }

                const timeslots = document.querySelectorAll('#time-slot-section #selectTimepickerOption-ts-dropdown .option');

                timeslots.forEach(slot => {
                    // Hide any slot not in the day's open list.
                    if (!dayState.openSlots.includes(slot.dataset.value)) {
                        slot.classList.add('d-none');
                    }
                });
            }, 1);
        }

        const ctaMobile = document.getElementById("call2action");
        const ctaDesktop = document.getElementById("call2actionDesktop");

        const MOBILE_SCROLL_TRIGGER = 650;
        const DESKTOP_SCROLL_TRIGGER = 600;

        function toggleCTAs() {
            const isMobile = window.innerWidth <= 768;
            const scrollY = window.scrollY;

            if (ctaMobile) {
                if (isMobile && scrollY > MOBILE_SCROLL_TRIGGER) {
                    ctaMobile.classList.remove("d-none");
                } else {
                    ctaMobile.classList.add("d-none");
                }
            }

            if (ctaDesktop) {
                if (!isMobile && scrollY > DESKTOP_SCROLL_TRIGGER) {
                    ctaDesktop.classList.remove("d-none");
                } else {
                    ctaDesktop.classList.add("d-none");
                }
            }
        }

        if (ctaMobile || ctaDesktop) {
            toggleCTAs();
            window.addEventListener("scroll", toggleCTAs);
            window.addEventListener("resize", toggleCTAs);
        }

    }
)
